import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    blue: {
      50: '#e6f1ff',
      100: '#c4daff',
      200: '#a1c2ff',
      300: '#7eaaff',
      400: '#5b92ff',
      500: '#3182CE', // Primary blue from dev_board_test
      600: '#2C5282', // Darker blue from dev_board_test
      700: '#1a365d',
      800: '#153e75',
      900: '#1a202c',
    },
  },
  fonts: {
    heading: '"Poppins", sans-serif',
    body: '"Inter", sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'semibold',
        borderRadius: 'md',
      },
    },
    Link: {
      baseStyle: {
        _hover: {
          textDecoration: 'none',
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: '700',
      },
    },
  },
  shadows: {
    xl: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  breakpoints: {
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em',
  },
});

export default theme;










// import { extendTheme } from '@chakra-ui/react';

// const theme = extendTheme({
//   colors: {
//     blue: {
//       50: '#e6f1ff',
//       100: '#c4daff',
//       200: '#a1c2ff',
//       300: '#7eaaff',
//       400: '#5b92ff',
//       500: '#3182CE', // Primary blue from dev_board_test
//       600: '#2C5282', // Darker blue from dev_board_test
//       700: '#1a365d',
//       800: '#153e75',
//       900: '#1a202c',
//     },
//   },
//   fonts: {
//     heading: '"Poppins", sans-serif',
//     body: '"Inter", sans-serif',
//   },
//   styles: {
//     global: {
//       body: {
//         bg: 'gray.50',
//         color: 'gray.800',
//       },
//     },
//   },
//   components: {
//     Button: {
//       baseStyle: {
//         fontWeight: 'semibold',
//         borderRadius: 'md',
//       },
//     },
//   },
// });

// export default theme;
